import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import MainLayout from '../../Layout/main';

import Header from '../../Components/header-interna';
import ConteudoPrincipal from './Sections/conteudo-principal';
import Video from './Sections/video';

const IntegraPalestrante: React.FC<any> = ({initialData} : any) => {
    const { name } = useParams<{ name: string }>();
    const [palestra] = useState<any>(initialData?.palestra);
    const [desc, setDesc] = useState<string>(initialData?.palestra.content);

    useEffect(() => {
        if(palestra && palestra.content){
            setDesc(palestra?.content)
        }
    }, [palestra]);

    const descFormat = (html: string, maxLength = 150): string => {
        const plainText = html.replace(/<[^>]*>/g, '');
      
        return plainText.length > maxLength
          ? plainText.slice(0, maxLength).trim() + '...'
          : plainText;
      };

    const breadcrumb = [{
        name: 'Palestrante',
        slug: 'palestrante/'+name,
    }];

    const url = import.meta.env.VITE_APP_DOMAIN + useLocation().pathname;  

    return (
        <>
            {palestra && (
                <Helmet>
                    <title>{palestra.title} - Uniexpo</title>
                    <meta name="description" content={palestra.yoast_desc || descFormat(desc) || ''} />

                    <meta property="og:type" content="profile" />
                    <meta property="og:url" content={url} />
                    <meta property="og:title" content={`${palestra.title} - Uniexpo`} />
                    <meta property="og:description" content={palestra.yoast_desc || descFormat(desc) || ''} />
                    <meta property="og:image" content={palestra.palestrante.foto} />
                    <meta property="og:image:secure_url" content={palestra.palestrante.foto} />
                    <meta property="og:image:type" content="image/jpeg" />
                    <meta property="og:site_name" content="Uniexpo" />

                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content={`${palestra.title} - Uniexpo`} />
                    <meta name="twitter:description" content={palestra.yoast_desc || descFormat(desc) || ''} />
                    <meta name="twitter:image" content={palestra.palestrante.foto} />
                </Helmet>
            )}

            <MainLayout desc>
                <Header title="Palestrante" breadcrumb={breadcrumb} />
                <ConteudoPrincipal palestra={palestra}/>

                {palestra?.video && 
                    <Video video={palestra?.video}/>
                }
            </ MainLayout>
        </>
    );
};

export default IntegraPalestrante;
